const state = {
    collection_statuses:[
        {
            "value": "LEGAL",
            "description": "La venta se encuentra en proceso legal para ser pagada.",
            "chipColor": "#ecd3d3",
            "textColor": "#a20000"
        },
        {
            "value": "FACTURADO",
            "description": "Ya se envió la factura al cliente.",
            "chipColor": "#dcd6ea",
            "textColor": "#2b2b2b"
        },
        /*{
            "value": "PÚBLICO EN GENERAL",
            "description": "Se tiene que facturar a público en general.",
            "chipColor": "#e2cfdc",
            "textColor": "#2b2b2b"
        },*/
        {
            "value": "PAGO EN EFECTIVO",
            "description": "El pago se realiza en efectivo.",
            "chipColor": "#dce7d5",
            "textColor": "#2b2b2b"
        },
        /*{
            "value": "FACTURA AGENDADA",
            "description": "Se tiene fecha programada para generar la factura.",
            "chipColor": "#d5dee4",
            "textColor": "#2b2b2b"
        },*/
        {
            "value": "REVISANDO ESTATUS",
            "description": "Se están revisando los detalles de pago.",
            "chipColor": "#eef4c8",
            "textColor": "#2b2b2b"
        },
        {
            "value": "POR INICIAR",
            "description": "La campaña aún no empieza.",
            "chipColor": "#cdeee0",
            "textColor": "#2b2b2b"
        },
        {
            "value": "RED FLAG",
            "description": "Sin respuesta del cliente.",
            "chipColor": "#e5dfd0",
            "textColor": "#2b2b2b"
        },
        {
            "value": "PAGADO POR MARCA",
            "description": "",
            "chipColor": "#d5dee4",
            "textColor": "#2b2b2b"
        },
    ],
};
const getters = {};

const actions = {};

const mutations = {};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}